import React, { useEffect, useRef } from 'react';

const WelcomeVideo = ({ onComplete }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('error', (e) => {
        console.error('Video error:', e);
      });
      videoRef.current.addEventListener('loadeddata', () => {
        console.log('Video loaded successfully');
      });
      videoRef.current.addEventListener('play', () => {
        console.log('Video started playing');
      });
    }
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-4 rounded-lg relative max-w-[95vw] w-[400px]">
        <video
          ref={videoRef}
          className="w-full h-auto rounded-lg"
          controls
          playsInline
          muted
          autoPlay
          preload="auto"
        >
          <source src="/videos/fixed_video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        <div className="mt-4 flex justify-center">
          <button
            onClick={onComplete}
            className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium text-sm"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeVideo; 